import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

localStorage.setItem("agritech-language", "es");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
